import React from 'react';
import PropTypes from 'prop-types';
import { Button, Header } from 'semantic-ui-react';

import Special from '../../molecules/Special';
import './Specials.css';

class Specials extends React.Component {
  render() {
    const { color, btnText, btnAction, specials, type, ...rest } = this.props;
    return (
      <React.Fragment>
        <Header as="h1" align="center">
          Specials
        </Header>
        <Special specials={specials} type={type} {...rest} />
        <div className="specials-order-button">
          <Button color={color} onClick={btnAction} size="large">
            {btnText}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}

Specials.propTypes = {
  specials: PropTypes.shape({
    schedules: PropTypes.array,
    categories: PropTypes.array,
    items: PropTypes.array,
    modifierSets: PropTypes.array,
    modifiers: PropTypes.array,
  }).isRequired,
  btnText: PropTypes.string.isRequired,
  btnAction: PropTypes.func.isRequired,
  color: PropTypes.string,
  type: PropTypes.oneOf(['default', 'carousel']),
};

Specials.defaultProps = {
  color: 'orange',
  type: 'default',
};

export default Specials;
